import { Link } from 'react-router-dom';
import { ArrowRightSvg } from '~/svg';
import { MdFlag, MdOutlineFlag, MdOutlineFileDownload } from 'react-icons/md';
import { FiEye } from 'react-icons/fi';

const FundRequestsUpdates = () => {
    return (
        <section className='data-table-common mb-7.5 h-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark'>
            <div className='flex flex-col gap-3 p-4 pb-2 sm:flex-row sm:items-center sm:justify-between md:p-6 md:pb-2 xl:p-7.5 xl:pb-2'>
                <h2 className='text-xl font-semibold text-black dark:text-white'>
                    Fund Requests Updates (24)
                </h2>

                <Link
                    to='/fund-requests?status=open'
                    className='flex items-center gap-2 text-primary'
                >
                    View All <ArrowRightSvg />
                </Link>
            </div>

            <div
                className='flex items-center justify-between px-8 py-1'
                style={{ fontSize: '12px' }}
            >
                <p>Showing 10 of 999</p>

                <div className='flex items-center gap-5'>
                    <div className='inline-flex items-center justify-center gap-1.5'>
                        <FiEye className='text-primary' size={18} />
                        View
                    </div>
                    <div className='inline-flex items-center justify-center gap-1.5'>
                        <MdOutlineFileDownload
                            className='text-primary'
                            size={18}
                        />
                        Download PDF
                    </div>
                </div>
            </div>

            <div className='overflow-x-auto'>
                <table className='datatable-table datatable-one w-full table-auto border-collapse break-words px-4 md:table-fixed md:px-8'>
                    <thead className='border-separate px-4'>
                        <tr style={{ fontSize: '14px' }}>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                <MdOutlineFlag size={24} />
                            </th>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                Client
                            </th>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                Payee
                            </th>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                Status
                            </th>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                Last Updated
                            </th>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                Items
                            </th>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                Amount
                            </th>
                            <th
                                className='text-secondary'
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className='border-t border-stroke'>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                <MdFlag className='text-danger' size={24} />
                            </td>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                <a href='#' className='text-primary'>
                                    Florence S.
                                </a>
                                <div className={'text-[12px]/[16px]'}>
                                    NTAFID
                                </div>
                            </td>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                <a href='#' className='text-primary'>
                                    Transportation Services
                                </a>
                                <div className={'text-[12px]/[16px]'}>
                                    Vendor ID
                                </div>
                            </td>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                <div className='inline-flex rounded-full bg-warning px-3 py-1 text-[12px]/[14.4px] hover:bg-opacity-90'>
                                    AP Review
                                </div>
                            </td>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                00/00/0000
                                <div className={'text-[12px]/[16px]'}>
                                    Changed to AP Review
                                </div>
                            </td>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                3
                            </td>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                $0.00
                            </td>
                            <td
                                style={{
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                }}
                            >
                                <div className='flex items-center gap-3'>
                                    <FiEye className='text-primary' size={20} />
                                    <MdOutlineFileDownload
                                        className='text-primary'
                                        size={20}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default FundRequestsUpdates;
